import { render } from "./PrintedVertical.vue?vue&type=template&id=f4c4c39a&scoped=true"
import script from "./PrintedVertical.vue?vue&type=script&lang=js"
export * from "./PrintedVertical.vue?vue&type=script&lang=js"

import "./PrintedVertical.vue?vue&type=style&index=0&id=f4c4c39a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c4c39a"]])

export default __exports__